import React, { useState } from "react";
import {
  Confirm,
  DeleteButton,
  Edit,
  SaveButton,
  ShowButton,
  SimpleForm,
  Toolbar,
  TopToolbar,
  useEditController,
  useNotify,
  useRedirect,
  useSaveContext,
} from "react-admin";
import { useForm } from "react-final-form";

import { logError } from "../../../utils/appUtils";
import { BackButton } from "../../../components/common/BackButton";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { HelpButton } from "../../../components/common/HelpButton";
import { UserEditHelp } from "./UserHelp";
import { AnnouncementForm } from "./AnnouncementForm";

const TenantConfirmingSaveButton = (props) => {
  const { saving, handleSubmitWithRedirect: ctxHandleSubmitWithRedirect } =
    useSaveContext();
  const form = useForm();
  const [showConfirm, setShowConfirm] = useState(false);
  const [pendingRedirect, setPendingRedirect] = useState();

  const submitWithRedirect =
    props.handleSubmitWithRedirect || ctxHandleSubmitWithRedirect;

  const triggerSubmit = (redirectTo) => {
    const formState = form?.getState();
    const formData = formState?.values || {};
    if (formData.active === "true" && !formData.tenantId) {
      setPendingRedirect(redirectTo);
      setShowConfirm(true);
      return;
    }
    submitWithRedirect?.(redirectTo);
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    submitWithRedirect?.(pendingRedirect);
  };

  const handleClose = () => setShowConfirm(false);

  return (
    <>
      <SaveButton
        {...props}
        saving={saving}
        handleSubmitWithRedirect={triggerSubmit}
      />
      <Confirm
        isOpen={showConfirm}
        title="No Tenant Selected"
        content="No tenant is selected. Proceed to save this announcement?"
        onConfirm={handleConfirm}
        onClose={handleClose}
      />
    </>
  );
};

export const AnnouncementEdit = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { record } = useEditController(props);

  const transform = (data) => ({
    ...data,
    activatedAt: data.active === "true" ? new Date() : data.activatedAt,
  });

  const onSuccess = ({ data }) => {
    debugger;
    notify(`Announcement updated successfully.`);
    redirect("/announcements");
  };

  const onFailure = (error) => {
    logError("announcements:AnnouncementEdit:onFailure", error, notify);
  };

  const EditActions = ({ basePath, data }) => (
    <TopToolbar>
      <HelpButton>
        <UserEditHelp {...props} />
      </HelpButton>
      <ShowButton basePath={basePath} record={data} />
      <BackButton basePath={basePath} />
    </TopToolbar>
  );

  const EditToolbar = (props) => (
    <Toolbar style={{ justifyContent: "space-between" }} {...props}>
      <TenantConfirmingSaveButton
        label="Save"
        transform={transform}
        onSuccess={onSuccess}
        onFailure={onFailure}
      />
      <DeleteButton record={props.record} />
    </Toolbar>
  );

  return (
    <Edit
      {...props}
      title={<ForceTitle title="Edit Announcement" />}
      mutationMode="pessimistic"
      actions={<EditActions />}
    >
      <SimpleForm
        variant="outlined"
        submitOnEnter={false}
        toolbar={<EditToolbar />}
      >
        <AnnouncementForm record={record} />
      </SimpleForm>
    </Edit>
  );
};
